module.exports = __webpack_public_path__ + "img/1e551cd.svg";